import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme,
    InputLabel,
    Tooltip
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getPartnerById, deletePartner, postPartner, updatePartner } from "../../../../api/partner";
import { Delete, Visibility } from "@material-ui/icons";
import { SERVER_URL } from "../../../../api";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import { buttonsStyle } from "../../../components/tables/table";
// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyPartner() {
    return {
        fullName: "",
        logoURL: "",
        order: null,
        active: true
    };
}

function logoSection(selectedLogo, setSelectedLogo, partner, setPartner, openPreviewDialog, setOpenPreviewDialog) {
    return (
        <div className="mt-2">
            <InputLabel>Logo</InputLabel>
            <label htmlFor={"upload-media"} className="ml-0 mb-4 mt-1" >
                <input
                    style={{ display: "none" }}
                    id={"upload-media"}
                    name={"upload-media"}
                    type="file"
                    accept={"image/*"}
                    onChange={(e) => {
                        setSelectedLogo(e.target.files[0]);
                    }}
                />
                <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                >
                    {selectedLogo ||
                        (partner.logoURL && partner.logoURL !== "")
                        ? "Change media"
                        : "Upload media"}
                </Button>
            </label>
            {(selectedLogo ||
                (partner.logoURL && partner.logoURL !== "")) && (
                    <>
                        <Tooltip title={"Preview"}>
                            <Button
                                size="small"
                                onClick={() => setOpenPreviewDialog(true)}
                                style={{
                                    ...buttonsStyle,
                                    marginRight: "15px",
                                }}
                            >
                                <Visibility />
                            </Button>
                        </Tooltip>
                        <PreviewDialog
                            title={"Preview"}
                            open={openPreviewDialog}
                            setOpen={setOpenPreviewDialog}
                            file={selectedLogo}
                            src={
                                selectedLogo
                                    ? URL.createObjectURL(selectedLogo)
                                    : `${SERVER_URL}/${partner.logoURL}`
                            }
                        />
                        <Tooltip title={"Delete"}>
                            <Button
                                size="small"
                                onClick={() => {
                                    setSelectedLogo(null);
                                    setPartner({
                                        ...partner,
                                        logoURL: null,
                                    });
                                }}
                            >
                                <Delete />
                            </Button>
                        </Tooltip>
                    </>
                )}
        </div>
    );
}

export default function EditPartnersPage() {
    const partnerId = useParams().id;
    const history = useHistory();
    const {
        isLoading: isLoadingData,
        disableLoading: disableLoadingData,
        ContentSkeleton,
    } = useSkeleton();

    const [partner, setPartner] = useState(getEmptyPartner());
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const [selectedLogo, setSelectedLogo] = useState(null);
    const [openPreviewDialog, setOpenPreviewDialog] = useState(null);

    useEffect(() => {
        if (!partnerId) {
            disableLoadingData();
            return;
        }

        getPartnerById(partnerId)
            .then((res) => {
                setPartner(res.data);
                disableLoadingData();
            })
            .catch((error) => {
                alertError({
                    error: error,
                    customMessage: "Could not get the partner.",
                });
                history.push("/partners");
            });
    }, [partnerId, disableLoadingData, history]);

    function savePartner() {
        if (!partnerId) {
            postPartner(partner, selectedLogo)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Partner created successfully.",
                    });
                    history.push("/partners");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the partner.",
                    });
                });
        } else {
            updatePartner(partnerId, partner, selectedLogo)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Changes saved successfully.",
                    });
                    history.push("/partners");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the partner.",
                    });
                });
        }
    }

    const handleChange = (element) => (event) => {
        setPartner({ ...partner, [element]: event.target.value });
    };

    if (isLoadingData)
        return <ContentSkeleton />;

    return (
        <>
            <Card>
                <CardHeader title="Edit partner"></CardHeader>
                <CardBody>
                    <div className="d-flex align-item-center">
                        <div className="col-5">
                            <TextField
                                label="Partner name"
                                value={partner.fullName}
                                onChange={handleChange("fullName")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </div>
                        <div className="col-4">
                            {logoSection(selectedLogo, setSelectedLogo, partner, setPartner, openPreviewDialog, setOpenPreviewDialog)}
                        </div>
                    </div>
                </CardBody>
            </Card>


            <div style={{ display: "flex", flexDirection: "row" }}>
                <Button
                    onClick={() => history.push("/partners")}
                    variant="outlined"
                    style={{ marginRight: "20px" }}
                >
                    Back
                </Button>

                <Button
                    onClick={() => savePartner()}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                >
                    Save partner
                </Button>

                {partnerId && (
                    <>
                        <MuiThemeProvider theme={theme}>
                            <Button
                                onClick={() => setOpenConfirmDialog(true)}
                                variant="outlined"
                                color="secondary"
                                style={{ marginRight: "20px" }}
                            >
                                Delete partner
                            </Button>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginLeft: "auto",
                                }}
                            ></div>
                        </MuiThemeProvider>

                        <ConfirmDialog
                            title={"Are you sure you want to delete this partner?"}
                            open={openConfirmDialog}
                            setOpen={setOpenConfirmDialog}
                            onConfirm={() => {
                                deletePartner(partnerId)
                                    .then((res) => {
                                        alertSuccess({
                                            title: "Deleted!",
                                            customMessage: "Partner deleted successfully.",
                                        });
                                        history.push("/partners");
                                    })
                                    .catch((error) => {
                                        alertError({
                                            error: error,
                                            customMessage: "Could not delete the partner.",
                                        });
                                    });
                            }}
                        />
                    </>
                )}
            </div>
        </>
    );
}
